<!--
    @修改内容
-->
<template>
    <div class="changecon" v-if="isShow">
        <SectionTitle title="修改内容"></SectionTitle>
        <div class="changecon-table">
            <el-table
                ref="table"
                border
                :data="tableData"
                :header-cell-style="this.$globalGrayTableHeaderStyle"
            >
                <el-table-column label="修改次数" width="100" align="center" type="index"></el-table-column>
                <el-table-column label="修改内容简述" :show-overflow-tooltip='true'>
                    <template slot-scope="scope">
                        <el-button v-if="(!scope.row.id || scope.row.editable) && !scope.row.modifyProfile" type="primary" size="mini" @click="editClick(scope.$index,scope.row.modifyProfile)">编辑修改简述</el-button>
                        <span v-else>{{scope.row.modifyProfile}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="修改时间" width="200" align="center" prop="modifyTime"></el-table-column>
                <el-table-column label="修改操作" width="160" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" v-if="scope.row.id&&!scope.row.editable" @click="historyVersion(scope.row)">查看历史版本</el-button>
                        <el-button type="text" v-else-if="scope.row.modifyProfile||scope.row.editable" @click="editClick(scope.$index,scope.row.modifyProfile)">修改描述</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-dialog
            :visible="visiter"
            width="600px"
            title="修改内容描述"
            :before-close="cancelClick"
            :modal-append-to-body="false"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
        >
            <el-input
                type="textarea" 
                v-model="modifyProfile"
                maxlength="2000" 
                show-word-limit 
                :autosize="{ minRows: 8, maxRows: 8}"
            ></el-input>
            <template #footer>
                <div class="dialog-btns">
                    <el-button @click="cancelClick">取消</el-button>
                    <el-button type="primary" @click="submit">确定</el-button>
                </div>
            </template>
        </el-dialog>
    </div>
</template>

<script>
import SectionTitle from './SectionTitle.vue';
import { throttle, debounce } from "lodash";
export default {
    components: {
        SectionTitle,
    },
    props: {
        isChange: {
            type: Boolean
        },
        modifyProfileList: {
            type: Array,
            default: function() {
                return []
            }
        },
        status: {
            type: Number,
            default: 1
        }
    },
    data() {
        return {
            tableData: [],
            visiter: false,
            modifyProfile: '',//弹框内容描述
            currIndex: 0,//当前编辑的index
            isShow: false
        }
    },
    
    methods: {
        // apiApplicationDocumentlistModifyProfile(type) {//获取修改内容
        //     apiApplicationDocumentlistModifyProfile({groupId:this.$parent.ruleForm.groupId}).then(({data}) => {
        //         if(data.code == '1') {
        //             this.tableData = data.data;
        //             this.isChange==true&&this.tableData.push(JSON.parse(JSON.stringify({})));
        //             // type==true&&this.tableData.push(JSON.parse(JSON.stringify({})));
        //         }
        //     })
        // },
        init() {
            this.$nextTick(() => {
                this.tableData = this.modifyProfileList;
                let length = this.modifyProfileList.length;
                if((this.isChange==true && this.modifyProfileList.length>0) || (this.isChange==true && this.status == 2)) {
                    if(!this.modifyProfileList[length-1]?.editable) { 
                        this.tableData.push(JSON.parse(JSON.stringify({})));
                    }
                }
                if(this.modifyProfileList.length>0 || this.status == 2) {
                    this.isShow = true;
                }else {
                    this.isShow = false;
                }
            })
        },
        editClick(currIndex,modifyProfile) {//编辑修改简述
            this.visiter = true;
            this.currIndex = currIndex;
            this.modifyProfile = modifyProfile;
        },
        historyVersion(arg) {//查看历史版本
            removeTabHandle('officialDocProcessHistory')
			this.$router.push({
				name: 'officialDocProcessHistory',
				query: {
                    id: arg.id,
                    groupId: this.$parent.ruleForm.groupId,
                    version: this.$parent.ruleForm.version
                }
			})
        },
        cancelClick() {
            this.visiter = false;
            this.modifyProfile = '';
        },
        submit:debounce(function() {
            let temp = JSON.parse(JSON.stringify(this.tableData))
            temp[this.currIndex].modifyProfile = this.modifyProfile;
            this.tableData = temp;
            this.visiter = false;
            this.$emit('emitChangeCon',this.modifyProfile);
            this.modifyProfile = '';
        },1000,{
            leading: true,
            trailing: false
        })
    }
}
</script>

<style lang="scss" scoped>
.changecon {
    margin-bottom: 20px;
    .changecon-table {
        margin: 0 100px;
    }
}
</style>